import React, { useEffect, useRef, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import "./gooleMap.scss";
import pinIcon from "../assets/images/map-pin_42x49.png";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const GoogleMapComponent = ({
  latLngList,
  // resizeImg = true,
  zoomLevel = 9.5,
  needIcon = false,
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyD1K1bDWE33hpnEO-nIZ3LdIfAzvpCcyjQ",
    // googleMapsApiKey: "AIzaSyBvFmBGNtVwAK62ZIln9C0yML0mBG9KVg0",
  });
  const mapRef = useRef(null);
  const [center, setCenter] = useState();
  const [zoom, setZoom] = useState(zoomLevel);
  useEffect(() => {
    if (latLngList.length === 1) {
      setCenter(latLngList[0]);
      setZoom(zoomLevel);
    } else if (mapRef.current && latLngList.length > 1) {
      const bounds = new window.google.maps.LatLngBounds();
      latLngList.forEach((loc) => {
        bounds.extend(new window.google.maps.LatLng(loc.lat, loc.lng));
      });
      mapRef.current.fitBounds(bounds);
    }
  }, [latLngList]);

  if (!isLoaded) {
    return null;
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      onLoad={(map) => (mapRef.current = map)}
      zoom={zoom}
      center={center}
      options={{
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        keyboardShortcuts: true,
        scrollwheel: false,
        disableDefaultUI: false,
        draggable: false,
        disableDoubleClickZoom: true,
      }}
    >
      {latLngList?.map((location, index) => (
        <Marker
          key={index}
          position={{ lat: location.lat, lng: location.lng }}
          title="My Location"
          {...(needIcon
            ? {
                icon: {
                  url: pinIcon,
                },
              }
            : {})}
        />
      ))}
    </GoogleMap>
  );
};

export default GoogleMapComponent;
